/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { useParams } from 'react-router-dom';
import { validate as uuidValidate } from 'uuid';

import { HTTPError } from '@/components/HTTPError';
import { SubtenantDetailsPage } from '@/pages/SubtenantDetailsPage/SubtenantDetailsPage';

export function SubtenantDetailsRoute() {
  const { id: subtenantId } = useParams<'id'>();

  if (!subtenantId || !uuidValidate(subtenantId)) {
    return <HTTPError httpStatus="404" />;
  }

  return <SubtenantDetailsPage subtenantId={subtenantId} />;
}
